module.exports = __webpack_public_path__ + "static/media/effect_button_random.7bdf1c37.mp3";